// ============================================
// CONSTANTES DO SISTEMA
// ============================================

// Perfis de Usuario
export const PERFIS = {
  ADMIN: 'ADMIN',
  GERENTE: 'GERENTE',
  CAIXA: 'CAIXA',
} as const;

export const PERFIS_OPTIONS = [
  { value: 'ADMIN', label: 'Administrador' },
  { value: 'GERENTE', label: 'Gerente' },
  { value: 'CAIXA', label: 'Caixa' },
];

// Unidades de Medida
export const UNIDADES = {
  UN: 'UN',
  M: 'M',
  M2: 'M2',
  M3: 'M3',
  KG: 'KG',
} as const;

export const UNIDADES_OPTIONS = [
  { value: 'UN', label: 'Unidade' },
  { value: 'M', label: 'Metro' },
  { value: 'M2', label: 'Metro²' },
  { value: 'M3', label: 'Metro³' },
  { value: 'KG', label: 'Quilograma' },
];

// Formas de Pagamento
export const FORMAS_PAGAMENTO = {
  DINHEIRO: 'DINHEIRO',
  CARTAO_CREDITO: 'CARTAO_CREDITO',
  CARTAO_DEBITO: 'CARTAO_DEBITO',
  PIX: 'PIX',
  FIADO: 'FIADO',
  CHEQUE: 'CHEQUE',
} as const;

export const FORMAS_PAGAMENTO_OPTIONS = [
  { value: 'DINHEIRO', label: 'Dinheiro' },
  { value: 'CARTAO_CREDITO', label: 'Cartão de Crédito' },
  { value: 'CARTAO_DEBITO', label: 'Cartão de Débito' },
  { value: 'PIX', label: 'PIX' },
  { value: 'FIADO', label: 'Fiado' },
  { value: 'CHEQUE', label: 'Cheque' },
];

export const FORMA_PAGAMENTO_LABELS: Record<string, string> = {
  DINHEIRO: 'Dinheiro',
  CARTAO_CREDITO: 'Cartão de Crédito',
  CARTAO_DEBITO: 'Cartão de Débito',
  PIX: 'PIX',
  FIADO: 'Fiado',
  CHEQUE: 'Cheque',
};

// Status de Venda
export const STATUS_VENDA = {
  PENDENTE: 'PENDENTE',
  FINALIZADA: 'FINALIZADA',
  CANCELADA: 'CANCELADA',
} as const;

export const STATUS_VENDA_OPTIONS = [
  { value: 'PENDENTE', label: 'Pendente' },
  { value: 'FINALIZADA', label: 'Finalizada' },
  { value: 'CANCELADA', label: 'Cancelada' },
];

// Tipos de Movimentacao
export const TIPOS_MOVIMENTACAO = {
  ENTRADA: 'ENTRADA',
  SAIDA: 'SAIDA',
  AJUSTE: 'AJUSTE',
} as const;

export const TIPOS_MOVIMENTACAO_OPTIONS = [
  { value: 'ENTRADA', label: 'Entrada' },
  { value: 'SAIDA', label: 'Saída' },
  { value: 'AJUSTE', label: 'Ajuste' },
];

// Estados Brasileiros
export const ESTADOS_BRASIL = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goiás' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PR', label: 'Paraná' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraima' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'TO', label: 'Tocantins' },
];

// Paginacao
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  LIMIT_OPTIONS: [10, 25, 50, 100],
};

// Local Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: '@daex:accessToken',
  REFRESH_TOKEN: '@daex:refreshToken',
  USER: '@daex:user',
  THEME: '@daex:theme',
};

// API URL
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Mensagens
export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Registro criado com sucesso!',
    UPDATE: 'Registro atualizado com sucesso!',
    DELETE: 'Registro excluído com sucesso!',
    LOGIN: 'Login realizado com sucesso!',
    LOGOUT: 'Logout realizado com sucesso!',
    SALE: 'Venda realizada com sucesso!',
    STOCK: 'Estoque atualizado com sucesso!',
  },
  ERROR: {
    GENERIC: 'Ocorreu um erro. Tente novamente.',
    LOGIN: 'Email ou senha inválidos.',
    UNAUTHORIZED: 'Você não tem permissão para esta ação.',
    NOT_FOUND: 'Registro não encontrado.',
    VALIDATION: 'Verifique os dados informados.',
    STOCK: 'Estoque insuficiente para esta operação.',
    CONNECTION: 'Erro de conexão com o servidor.',
  },
  CONFIRM: {
    DELETE: 'Tem certeza que deseja excluir este registro?',
    CANCEL_SALE: 'Tem certeza que deseja cancelar esta venda?',
    LOGOUT: 'Tem certeza que deseja sair?',
  },
};
